module.exports = __webpack_public_path__ + "static/media/2.99316b71.jpeg";